const checkoutEn = {
  "settings.checkout": "Checkout",
  "settings.checkout_hint": "Contact method, form fields, tipping and checkout style",
  "co.title": "Checkout",
  "co.preview": "Preview",
  "co.style": "Style",
  "co.style_hint": "Your logo and colours on the checkout and order status pages.",
  "co.logo": "Logo",
  "co.logo_add": "Add logo",
  "co.accent": "Buttons and accents",
  "co.radius": "Corner radius: {n}px",
  "co.sample": "Preview:",
  "co.pay_now": "Pay now",
  "co.contact": "Customer contact method",
  "co.contact_hint": "What customers use to check out and get order updates.",
  "co.contact_method": "Customers check out with",
  "co.contact.either": "Phone number or email",
  "co.contact.either_hint": "Customers choose: updates go by text or email.",
  "co.contact.email": "Email",
  "co.contact.phone": "Phone number",
  "co.contact.phone_hint": "Common in the Gulf: updates go by text message.",
  "co.require_login": "Require customers to log in before checkout",
  "co.require_login_hint": "Customers can only check out with an account.",
  "co.info": "Customer information",
  "co.full_name": "Full name",
  "co.name.last": "Only require last name",
  "co.name.both": "Require first and last name",
  "co.company": "Company name",
  "co.address2": "Address line 2 (apartment, unit, etc.)",
  "co.shipping_phone": "Shipping address phone number",
  "co.vis.hidden": "Don't include",
  "co.regional": "Address fields by country",
  "co.regional_hint": "Ask for the address details your couriers need in each country, such as Qatar's zone, street and building numbers. Every address keeps the standard fields too, so payments and couriers work everywhere.",
  "co.regional_other": "All other countries",
  "co.regional_on": "{n} on",
  "co.regional_off": "Standard address only",
  "co.regional_address1": "Make the address line optional",
  "co.regional_address1_hint": "When these fields already say where to deliver. Customers must still fill in the address line or one of them.",
  "co.vis.optional": "Optional",
  "co.vis.required": "Required",
  "co.marketing": "Marketing options",
  "co.marketing_hint": "Let customers sign up for marketing at checkout. Leave the box unticked where the law requires consent.",
  "co.mkt.email": "Email marketing",
  "co.mkt.sms": "SMS marketing",
  "co.mkt.hidden": "Don't show",
  "co.mkt.unchecked": "Show, unticked",
  "co.mkt.checked": "Show, ticked",
  "co.tipping": "Tipping",
  "co.tipping_enable": "Show tipping options at checkout",
  "co.tipping_hint": "Customers can add a tip as a percentage of their order.",
  "co.tip_n": "Option {n}",
  "co.processing": "Order processing",
  "co.billing_same": "Use the shipping address as the billing address by default",
  "co.notes": "Add a note field",
  "co.notes_hint": "Customers can leave a note with their order.",
  "co.terms": "Require customers to agree to the terms of service",
  "co.terms_hint": "A checkbox before \"Pay now\".",
  "ab.title": "Recovered carts",
  "ab.empty_title": "No carts to recover",
  "ab.empty_body": "Checkouts show here when a customer gives their contact details and leaves without paying.",
  "ab.search": "Search by email, phone or name",
  "ab.none": "No checkouts match.",
  "ab.col.checkout": "Checkout",
  "ab.col.date": "Date",
  "ab.col.placed_by": "Placed by",
  "ab.col.status": "Recovery status",
  "ab.col.total": "Total",
  "ab.recovered": "Recovered",
  "ab.not_recovered": "Not recovered",
  "ab.abandoned_on": "Abandoned {when}",
  "ab.details": "Checkout details",
  "ab.subtotal": "Subtotal",
  "ab.discount": "Discount",
  "ab.shipping": "Shipping",
  "ab.tax": "Taxes",
  "ab.tax_included": "Taxes (included)",
  "ab.total": "Total",
  "ab.recover": "Recover this checkout",
  "ab.recover_hint": "Send this link to the customer: it opens their checkout with everything they entered. Recovery emails arrive with marketing.",
  "ab.copy": "Copy link",
  "ab.copied": "Link copied",
  "ab.customer": "Customer",
  "ab.view_customer": "View customer",
  "ab.subscribed": "Subscribed to email marketing",
  "ab.not_subscribed": "Not subscribed to email marketing",
  "ab.shipping_address": "Shipping address",
  "ab.activity": "Activity",
  "ab.started": "Started {when}",
  "ab.last_seen": "Last active {when}",
} as const;

export default checkoutEn;
